import React from "react";
import styles from "./TeamModal.module.scss";
import ExitIcon from "../../../../assets/icons/ExitIcon";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../CustomButton/CustomButton";
import CustomSelect from "../../../CustomSelect/CustomSelect";

const TeamModal = ({ setModal }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.teamModal}>
      <div className={styles.teamModalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.headerTitle}>{t("teamModal.addEmployee")}</h2>
          <button>
            <ExitIcon onClick={() => setModal(false)} />
          </button>
        </div>
        <form action="" className={styles.modalForm}>
          <div className={styles.modalInput}>
            <label htmlFor="" className={styles.label}>
              {t("teamModal.email")}
            </label>
            <input
              type="text"
              placeholder={t("teamModal.emailPlaceholder")}
              className={styles.input}
            />
          </div>
          <div className={styles.formSelect}>
            <label htmlFor="">{t("teamModal.role")}</label>
            <CustomSelect placeholder={t("teamModal.integrator")} />
          </div>
        </form>
        <div className={styles.modalFooter}>
          <CustomButton onClick={() => setModal(false)}>
            {t("teamModal.cancel")}
          </CustomButton>
          <CustomButton blue>{t("teamModal.save")}</CustomButton>
        </div>
      </div>
    </div>
  );
};

export default TeamModal;
